<template lang="pug">
  div.inherit
    van-form
        van-field(class="inherit_form", disabled, v-model="newpwd")
        van-button(class="copy", type="danger", block, @click="copyHandle()") {{$t('copy')}}
        p {{$t('inherit_success_1')}}
        p {{$t('inherit_success_2')}}
        p {{$t('inherit_success_3')}}
        van-button(class="back_btn", type="danger", block, round, @click="backPage") {{$t('inheritReset')}}
</template>

<script>
import Clipboard from 'clipboard'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'inherit',
  data(){
    return {
        newpwd: '',
        isDisabled: false
    }
  },
  created(){
      
  },
  methods:{
    // ...mapActions(['getUserInfo']),
    backPage(){
      this.$router.push({
        path: '/user/inherit'
      });
    },
    copyHandle(){
      let data = this.newpwd
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return data
        }
      })
      clipboard.on('success', e => {
        Toast({
            message: this.$t('copy'),
            type: "success"
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast({
            message: this.$t('copied'),
            type: "fail"
        })
        clipboard.destroy()
      })
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token'])
  },
  mounted(){
    this.newpwd = this.uid
    // this.getUserInfo(Qs.stringify({
    //   appId: this.appid,
    //   uid: this.uid,
    //   deviceId: this.deviceId,
    //   accessToken: this.token
    // }));
  }
}
</script>
<style lang="scss" scoped>
.inherit{
    margin: 20px;
    .inherit_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .inherit_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
  p{
    margin: 5px;
    text-align: left;
    font-size: 15px;
    font-weight: normal;
    &.check_title{
      margin-top: 50px;
      font-size: 12px;
      color: #c7c7c7;
    }
  }
    .back_btn{
          margin-top: 50px;
          width: 90%;
          left: 5%;
          padding: 15px;
    }
    .copy{
      float: right;
      margin-top: -35px;
      width: 100px;
      line-height: 30px;
      margin-right: 10px;
      height: 30px;
    }
}
</style>